import { render, staticRenderFns } from "./n-xiaohei-data-template.vue?vue&type=template&id=f93c305e&scoped=true&"
import script from "./n-xiaohei-data-template.js?vue&type=script&lang=js&"
export * from "./n-xiaohei-data-template.js?vue&type=script&lang=js&"
import style0 from "./n-xiaohei-data-template.scss?vue&type=style&index=0&id=f93c305e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f93c305e",
  null
  
)

export default component.exports